import React, { useEffect, useState } from "react";
import styles from "@/components/OmniChannel/DateTimePicker.module.scss"
import Modal from "@/components/core/Modal/Modal";
import { startOfDay, addDays, isBefore, format } from "date-fns";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { confirmSlotAnalytics, noAvailableSlotsAnalytics, selectDateAnalytics, selectSlotAnalytics } from "@/components/OmniChannel/analytics"
import Button from "@/components/core/Button/Button";
const DateTimePicker =(props)=>{
  const {disabled, onChangeDateTime=()=>{}, isEdit = false, kecData={}, setIsEdit=()=>{}, monthlyAvailability={}, error={}, setError=()=>{}}=props
  const [isVisible, setIsVisible] = useState(false)
  const [selectedDate, setSelectedDate] = useState((format(new Date(),"yyyy-MM-dd")));
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [slots, setSlots] = useState([])
  const minDate = new Date()
  const maxDate = addDays(new Date(), 29)
  const TIME_SLOTS = [
  { apiKey: "11AM - 1PM", label: "11 am - 1 pm"},
  { apiKey: "1PM - 3PM", label: "1 pm - 3 pm"},
  { apiKey: "3PM - 5PM", label: "3 pm - 5 pm"},
  { apiKey: "5PM - 7PM", label: "5 pm - 7 pm" },
];
  const showDateTimePicker = (event)=>{
    if(disabled){
      event.preventDefault()
    }
    else{
      setIsVisible(true)
    }
  }
  const modalCloseHandler = ()=>{
    setIsVisible(false)
    setIsEdit(false)
    const element = document.getElementById("omni-channel-form")
    if (element) {
      setTimeout(function () {
        window.scrollTo({ top: element.offsetTop - 250, behavior: "smooth" })
      }, 50)
    }
    setError({
      ...error,
      "slot": "Please Choose Date & Time",
    })
  }
 const tileDisabled = ({ date, view }) => {
    if (view !== "month") return false;
    if (date < startOfDay(minDate) || date > startOfDay(maxDate)) return true;
    return false;
  };
  const  filterSlots=(slots, selectedDate) =>{
    const now = new Date();
    const selected = new Date(selectedDate);

    // Check if selected date is today
    const isToday =
        now.getFullYear() === selected.getFullYear() &&
        now.getMonth() === selected.getMonth() &&
        now.getDate() === selected.getDate();

    if (!isToday) {
        return slots; // return all slots
    }
    return Object.fromEntries(
        Object.entries(slots).filter(([timeRange]) => {
            const [startTime] = timeRange.split(" - ");

            const slotDate = new Date();
            const parsed = parseTime(startTime);

            slotDate.setHours(parsed.hours, parsed.minutes, 0);
            return slotDate > now; // keep future slots only
        })
    );
  }

  const  parseTime = (timeStr)=> {
    const match = timeStr.match(/(\d+)(AM|PM)/);
    let hours = parseInt(match[1]);
    const period = match[2];

    if (period === "PM" && hours !== 12) hours += 12;
    if (period === "AM" && hours === 12) hours = 0;

    return { hours, minutes: 0 };
  }
  const getSlotsForDate = (date)=>{
    if(Object.keys(monthlyAvailability).length){
      if(monthlyAvailability?.[date]?.isBlock || monthlyAvailability?.[date]?.isHoliday){
        setSlots([])
        noAvailableSlotsAnalytics(kecData)
      }
      else{
        let slotData = monthlyAvailability?.[date]
        const keysToRemove = ['isBlock', 'isHoliday'];
        keysToRemove.forEach(key => {
          delete slotData[key];
        });
        Object.entries(slotData).forEach(ele=>{
          if(ele[1]===0){
            delete slotData[ele[0]]
          }
        })
        slotData=filterSlots(slotData, date)
        const slotOutput =  [slotData].map((obj) => {
          return TIME_SLOTS.map(({ apiKey, label }) => ({
            apiKey,
            label,
            remaining: Number(obj[apiKey] ?? 0),
          })).filter((slot) => slot.remaining > 0);
        });
        if(slotOutput[0].length===0){
          noAvailableSlotsAnalytics(kecData)
        }
        setSlots(...slotOutput)
      }
    }
    else{
      setSlots([])
    }
  }
   const confirmSlot = ()=>{
    onChangeDateTime(selectedSlot, selectedDate)
    confirmSlotAnalytics(kecData)
    setIsVisible(false)
    setIsEdit(false)
    const element = document.getElementById("omni-channel-form")
    if (element) {
      if(element.offsetTop>250)
      setTimeout(function () {
        window.scrollTo({ top: element.offsetTop - 250, behavior: "smooth" })
      }, 50)
      else
         setTimeout(function () {
        window.scrollTo({ top: element.offsetTop+1900, behavior: "smooth" })
      }, 50)
    }
  }

  useEffect(()=>{
    if (!selectedDate) return;
    getSlotsForDate(selectedDate);
  },[isVisible, selectedDate])

  useEffect(()=>{
    if(isEdit){
      setSelectedDate(kecData?.appointmentDate)
      setSelectedSlot(kecData?.slot)
      setIsVisible(isEdit)
    }
  },[isEdit])
  return  (
    <div className={`${styles.imageUploadWrapper}`}>
      <div className="image-upload-content">
        <div className="file-upload-container">
          <div className="upload-button">
            <span className={`upload-button-text ${disabled?'disable':''}`} onClick={showDateTimePicker}>
              {"Select date & time"}
            </span>
            {error && error.slot!=="" && (
              <span className="file-upload-container__error-msg">{error.slot}</span>
            )}
          </div>
        </div>
      </div>
      {isVisible && 
        <Modal onModalClose={modalCloseHandler} showModal={isVisible}>
          <div className="my-calendar">
          <Calendar
            value={selectedDate}
            onChange={(v) => {
              const d = Array.isArray(v) ? v[0] : v;
              setSelectedDate((format(new Date(d),"yyyy-MM-dd")));
              setSelectedSlot(null);
              selectDateAnalytics((format(new Date(d),"yyyy-MM-dd")), kecData)
            }}
            minDetail="month"
            maxDetail="month"
            prev2Label={null}
            next2Label={null}
            tileDisabled={tileDisabled}     
          />
          </div>
          <div className="slots">    
            <div className="slot-grid">
              {slots?.length ===0 || Object.keys(slots?.[0]).length===0 ? (
                <div className="no-slots"><div className="no-slots-text">No available slots for this date.</div><div className="no-slots-text">Please select alternate date.</div></div>
              ) : (
                <>
                <h4 className="slots-title">Available slots</h4>
                <div>
                  {slots?.map((ele)=>{
                    const isSelected = selectedSlot && ele.apiKey === selectedSlot
                    return <div className={`slots-details ${isSelected?'selected':''}`}>
                      <div className="slot-text" onClick={()=>{
                        setSelectedSlot(ele.apiKey)
                        selectSlotAnalytics(ele.label, kecData)}}>{ele.label}</div>
                    </div>
                  })}
                </div>
                </>
              )}
            </div>
          </div>
          <Button
              className="gbh-data-layer"
              useDefaultClass={true}
              type="black"
              role="button"
              label={"Confirm Slot"}
              onClick={confirmSlot}
              customClass="slot-button"
              disabled={!selectedSlot}
          />
        </Modal>
        }
    </div>
  )
}

export default DateTimePicker